export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Astronomía · Buenos Aires',
    'En una tarde tenía más material sobre Astronomía contextualizado en Argentina que en toda mi carrera docente. Ahora mis alumnos y colegas me preguntan sobre el Sistema Solar, constelaciones, cosmología, exoplanetas y exploración espacial, y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-deep',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Docente de Ciencias Naturales · Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre la Astronomía tradicional y la observación del cielo austral contextualizada, y analizaron casos reales de fenómenos astronómicos con explicaciones científicas vigentes. El nivel de participación en las clases se multiplicó.',
    'bg-petrolDark',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Ciencias · Córdoba',
    'Las simulaciones de proyectos astronómicos con las plantillas del MEGAPACK son exactamente lo que necesitaba: modelos reales, organismos científicos argentinos, estándares internacionales actualizados, estrategias de observación segura. Cambió la forma en que planifico todo el año.',
    'bg-violet',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Astronomía',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué la Astronomía es importante, qué se sabe actualmente sobre exoplanetas y vida extraterrestre, y por qué cada descubrimiento astronómico existe porque la humanidad quiso entender el universo. Mis alumnos empezaron a ver la Astronomía como una aventura científica real. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Astronomía',
    'Cuando explicás que la Astronomía no es solo mirar el cielo, sino entender cómo funciona el universo, qué se ve desde el hemisferio sur, cómo se descubren exoplanetas y qué tecnología necesitamos para explorar el espacio, empieza un debate sobre el futuro de la humanidad y nuestra relación con el cosmos que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Astronomía',
    'Cuando mis alumnos descubren que Argentina tiene observatorios astronómicos de clase mundial, que existen astrónomos argentinos haciendo investigación de punta, que la observación del cielo desde el hemisferio sur permite ver objetos que otros no pueden ver, empieza una conversación sobre el valor de la investigación científica que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Astronomía',
    'Cerré mi planificación anual de Astronomía en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con contenidos actualizados, 100 proyectos para elegir y adaptar, 150 actividades listas para implementar y sistema de evaluación integrado.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Astronomía',
    'Cuando les digo a mis alumnos que el astrónomo que trabaja en un observatorio de Córdoba está haciendo lo mismo que los astrónomos de los grandes observatorios del mundo: buscando respuestas a los grandes misterios del universo, contribuyendo a expandir el conocimiento humano y quizás descubriendo algo que cambie para siempre nuestra comprensión del cosmos, les estoy enseñando lo que significa ser un científico en el mundo real.',
  ],
];
